



























































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import {
  defineComponent,
  ref,
  computed,
  watch,
  Ref,
  reactive,
  h
} from '@vue/composition-api'
import Vue from 'vue'
import { useRouter } from '@u3u/vue-hooks'
import { numberWithCommas } from '@/lib/utils'
import { useAxios } from '@vue-composable/axios'
import { useAuth } from '@/composables/useAuth'
import { useApp } from '@/composables/useApp'
import { AxiosBasicCredentials } from 'axios'
import { toDateString } from '@/lib/utils'
import moment from 'moment'

export default defineComponent({
  setup(_, { root }) {
    const { currentApp } = useApp()
    const { username, userToken } = useAuth()
    const auth = {
      username: username.value,
      password: userToken.value
    } as AxiosBasicCredentials

    const { route, router } = useRouter()
    const pageSize = 10
    const current = +(route.value.query['current'] ?? 1)

    const params = reactive({
      page: current,
      // eslint-disable-next-line
      page_size: pageSize
    })

    const { data: result, loading, error, exec } = useAxios()

    watch(
      () => params,
      params => {
        exec({
          url: `${currentApp.value.voidApiUri}/admin/campaigns`,
          method: 'GET',
          params,
          auth
        })
      },
      { deep: true, immediate: true }
    )

    watch(
      error,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred'
          })
        }
      },
      { immediate: true }
    )

    const data = computed(() => {
      const data = result.value
      if (data == null) {
        return { campaigns: [], pagination: {} }
      }
      const pagination = {
        total: data.pagination.total_entries,
        pageSize: data.pagination.page_size,
        current: data.pagination.page_number
      }
      return {
        campaigns: data.data,
        pagination
      }
    })

    const colRenderer = (data: string) =>
      h(
        'span',
        {
          class: data ? 'dd' : 'italic text-gray-500'
        },
        data ? data : 'N/A'
      )
    const columns = [
      {
        title: 'name',
        dataIndex: 'name',
        align: 'center'
      },
      {
        title: 'user type',
        dataIndex: 'applicable_user_type',
        customRender: colRenderer
      },
      {
        title: 'type',
        dataIndex: 'coupon_type',
        scopedSlots: { customRender: 'couponType' }
      },
      {
        title: 'duration (days)',
        dataIndex: 'duration',
        customRender: colRenderer
      },
      {
        title: 'price',
        dataIndex: 'fee',
        scopedSlots: { customRender: 'fee' }
      },
      {
        title: 'price category',
        dataIndex: 'fixed_price_category',
        customRender: colRenderer
      },
      {
        title: 'discount percent',
        dataIndex: 'discount_percentage',
        scopedSlots: { customRender: 'discount' }
      },
      {
        title: 'number of coupons',
        dataIndex: 'num_of_coupons',
        customRender: colRenderer
      },
      {
        title: 'max usage',
        dataIndex: 'max_usage',
        customRender: colRenderer
      },
      {
        title: 'valid from',
        dataIndex: 'valid_from',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: 'valid until',
        dataIndex: 'valid_til',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: 'created at',
        dataIndex: 'inserted_at',
        scopedSlots: { customRender: 'date' }
      }
    ]

    const handleTableChange = ({ current }: { current: number }) => {
      router.push({
        path: route.value.path,
        query: { ...route.value.query, current: `${current}` }
      })
      params.page = current
    }

    /// Modal
    // eslint-disable-next-line
    const campaign: Ref<null | any> = ref(null)
    const modalVisible = computed(() => campaign.value != null)
    // eslint-disable-next-line
    const showModal = (val: any) => {
      campaign.value = val
    }
    const hideModal = () => {
      campaign.value = null
      cancelCreate()
    }
    const newCampaign = () =>
      showModal({
        name: '',
        applicable_user_type: 'all',
        coupon_type: 'discount',
        fixed_price_category: 'annually',
        discount_percentage: 100,
        max_usage: 1
      })
    const {
      data: createdCampaign,
      loading: isCreating,
      error: createError,
      exec: execCreate,
      cancel: cancelCreate
    } = useAxios()
    const createCampaign = () => {
      execCreate({
        url: `${currentApp.value.voidApiUri}/admin/campaigns`,
        method: 'POST',
        data: {
          campaign: {
            ...campaign.value,
            fee: campaign.value['fee'] && campaign.value['fee'] * 100
          }
        },
        auth
      })
    }
    watch(
      createdCampaign,
      result => {
        // debugger
        if (result == null) {
          return
        }
        router.push({
          name: 'marketing.campaign-details',
          params: { id: result.data.id }
        })
      },
      { immediate: true }
    )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setCampaignValidFrom = (evt: any) => {
      Vue.set(campaign.value, 'valid_from', evt && evt.utc())
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setCampaignValidTil = (evt: any) => {
      Vue.set(campaign.value, 'valid_til', evt && evt.utc())
    }

    const toDate = moment

    const couponTypeClass = {
      extension: ['bg-teal-200', 'text-teal-600'],
      discount: ['bg-purple-200', 'text-purple-600'],
      fixed_price: ['bg-pink-200', 'text-pink-600']
    }

    const userTypes = [
      ['all', 'All'],
      ['premium', 'Premium uesrs'],
      ['premium_with_expired', 'Premium users & expired users'],
      ['expired', 'Expired users'],
      ['non_premium', 'Non-premium users'],
      ['non_premium_with_expired', 'Non-premium users & expired users']
    ]

    return {
      userTypes,
      numberWithCommas,

      handleTableChange,

      newCampaign,
      isCreating,
      createError,
      createCampaign,
      setCampaignValidFrom,
      setCampaignValidTil,

      loading,
      data,
      columns,

      modalVisible,
      campaign,
      showModal,
      hideModal,

      toDateString,
      toDate,
      couponTypeClass
    }
  }
})
